import { useEffect, useState } from "react";

import "./styles.css";

import "react-tabs/style/react-tabs.css";

import ProjectTable from "./index copy";
import UsuariosTable from "../Usuários";
import ClientesTable from "../Clientes";
import TemplateTable from "../TemplateConfigs";
import { InputIcon } from "../../components/ui/input";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { stepsConfiguracoes } from "../Tour/steps";
import { useTour } from "@reactour/tour";

export default function Projetos() {
  const menuItens = [
    { title: "Usuários", table: UsuariosTable },
    { title: "Projetos", table: ProjectTable },
    { title: "Clientes", table: ClientesTable },
    { title: "Modelos de Documento", table: TemplateTable },
  ];

  const [termoDePesquisa, setTermodePesquisa] = useState("");

  const [selectMenuItem, setSelectMenuItem] = useState(0);
  const { setSteps } = useTour();

  useEffect(() => {
    setSteps(stepsConfiguracoes);
  }, [setSteps]);

  const showItens = () => {
    if (selectMenuItem === 0) {
      return <UsuariosTable termoPesquisa={termoDePesquisa} />;
    } else if (selectMenuItem === 1) {
      return <ProjectTable termoPesquisa={termoDePesquisa} />;
    } else if (selectMenuItem === 2) {
      return <ClientesTable termoPesquisa={termoDePesquisa} />;
    } else {
      return <TemplateTable />;
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <nav
        className="navigation"
        style={{
          marginLeft: "20%",
          marginTop: "100px",
        }}
      >
        <ul>
          <li>
            <a href="/perfil">Home</a>
          </li>
          <li>/</li>
          <li>
            <a href="/configuracoes">Configurações</a>
          </li>
        </ul>
      </nav>
      <p
        className="configuracoesTitle"
        style={{
          fontSize: "35px",
          fontStyle: "normal",
          fontWeight: "700",
          color: "#00293B",
          margin: "auto",
          width: "fit-content",
        }}
      >
        {menuItens[selectMenuItem].title}
      </p>

      <div
        style={{
          borderBottom: "2px solid rgba(0, 105, 152, 0.55)",
          width: "90%",
          marginLeft: "70px",
        }}
      ></div>

      <div className="mt-[6rem] w-full flex flex-col justify-center">
        <nav
          className="w-[90%]  bg-[#EAF1F3] flex cursor-pointer rounded-t-xl pt-6 justify-between items-center mx-auto"
        >
          <ul className="flex gap-2">
            {menuItens.map((menuItem, index) => {
              return (
                <li
                  key={index}
                  className={`${
                    index === selectMenuItem &&
                    "border-b-4 border-[#3900DB] text-[#3900DB] "
                  } px-4 pt-2`}
                  onClick={() => setSelectMenuItem(index)}
                >
                  {menuItem.title}
                </li>
              );
            })}
          </ul>
          <div className="mb-2 mr-1 flex flex-grow justify-end">
            <InputIcon
              className="p-0 flex flex-row-reverse pr-3 w-[250px]"
              icon={<MagnifyingGlassIcon className="h-[18px] w-[16px]" />}
              value={termoDePesquisa}
              onChange={(event) => setTermodePesquisa(event.target.value)}
            />
          </div>
        </nav>
        
        <div
          className="flex mx-auto w-[90%]"
        >
        {showItens()}
        </div>
      </div>
    </div>
  );
}
